import { SVGProps } from "react";

const PATHS = [
  "m14.0625 6.5625 -0.9375 0.625 -0.9375 -0.625V5.625L13.125 5l0.9375 0.625v0.9375Z",
  "M14.0625 10.3125h0.625v-1.875l-1.5625 -0.625 -1.5625 0.625v1.875h0.625v2.5h1.875v-2.5Z",
  "M9.0625 14.0625v-3.75h1.25v-3.125l-2.5 -0.9375 -2.5 0.9375v3.125h1.25v3.75h2.5Z",
  "M7.8125 7.8125v1.875",
  "m9.6875 4.6875 -1.875 0.9375 -1.875 -0.9375v-2.5l1.875 -0.9375 1.875 0.9375v2.5Z",
  "M9.6875 2.8125H7.5l-1.5625 -0.625",
  "m3.4375 6.5625 -0.9375 0.625 -0.9375 -0.625V5.625L2.5 5l0.9375 0.625v0.9375Z",
  "M3.4375 10.3125h0.625v-1.875l-1.5625 -0.625 -1.5625 0.625v1.875h0.625v2.5h1.875v-2.5Z",
] as const;

export const AccountGroup4Icon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg
      fill="none"
      viewBox="-0.5 -0.5 16 16"
      width={size}
      height={size}
      {...rest}
    >
      {PATHS.map((d) => (
        <path
          key={d}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={d}
        />
      ))}
    </svg>
  );

  return render();
};
